import React, { createContext, useContext, useEffect, useState } from "react";
import { Urls } from "./Urls";
import axios from "./Axios";
import { UserApiContext } from "./Components/UserDetailsContext/UserDetailsContext";

export const MyCompanyProfileContext = createContext({});

export const MyCompanyProfileDetailsProvider = ({ children }) => {
  const [companySettingData, setCompanySettingData] = useState({});
  const { companyProfile, isContextLoading, userDetails } = useContext(UserApiContext);
  const [isCompanyProfileLoading, setIsCompanyProfileLoading] = useState(false);
  const [isUserinTeams, setIsUserinTeams] = useState(true);

  const fetchCompanyProfileDetails = async () => {
    setIsCompanyProfileLoading(true);

    const url = `${Urls.companyProfile}?company_id=${companyProfile?.domain_data?.company_id}&projections_enable=true`;
    const payload = {
      projections: {
        indent: 1,
        contact_information: 1,
        masters_setting: 1,
        organizations: 1,
        approver_data: 1,
        enquiry: 1,
        demo_vehicle_tracking: 1,
        vendor_groups: 1,
        default_currency: 1,
        logo: 1,
        default_map_region: 1,
        agent_settings : 1,
      },
    };

    try {
      // api call
      const { data } = await axios.post(url, payload);

      if (data?.length > 0) {
        setCompanySettingData(data?.[0]);
        const currentUser =
          (data?.length > 0 && data?.[0]?.contact_information?.find(
            (u) => u?.email === userDetails?.email
          )) ?? {};
        setIsUserinTeams(Object.keys(currentUser).length > 0);
      }
    } catch (error) {
      console.error(error, "error");
    }

    setIsCompanyProfileLoading(false);
  };

  useEffect(() => {
    if (companyProfile?.domain_data?.company_id) {
      fetchCompanyProfileDetails();
    } else if (companyProfile?.message === "company profile not allowed" || companyProfile?.company_id===null) {
      setIsUserinTeams(false);
    }
  }, [companyProfile]);

  const isContextReady = isContextLoading || isCompanyProfileLoading;

  return (
    <MyCompanyProfileContext.Provider
      value={{
        companySettingData,
        isUserinTeams,
        fetchCompanyProfileDetails,
        isContextReady,
      }}
    >
      {children}
    </MyCompanyProfileContext.Provider>
  );
};

export function useCompany() {
  return useContext(MyCompanyProfileContext);
}
